import React, { PureComponent, Fragment } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { Loader } from 'modules/shared'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { DateTime } from 'luxon'
import { emissToDate, dateIdToDate, toMoney, getHTTPClient, showNotification } from 'helpers'

const { SearchBar } = Search
const titles = {
    venda_detalhada: 'Venda detalhada',
    notas_emitidas: 'Notas Emitidas',
    diferencas: 'Diferenças',
    duplicidades: 'Duplicidades',
    correcoes: 'Correções mês anterior',
    nfs_complementares: 'Notas complementares',
    rejeitadas: 'Vendas rejeitadas',
    vendas_sem_numero: 'Vendas sem número',
    notasF: 'Notas tipo F'
}

const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return (
        <button className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
    )
}

const emissFormat = cell => emissToDate(cell)
const dateFormat = cell => dateIdToDate(cell)
const moneyFormat = cell => toMoney(cell)

class NfceDetail extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            dados: []
        }
        this.closeBtn = React.createRef()
        this.table = React.createRef()
        this.onClose = this.onClose.bind(this)
    }

    getTitle() {
        return `${this.props.content.nomeEmpresa} - ${titles[this.props.content.type]} (${DateTime.fromJSDate(this.props.dateIni).toFormat('dd/MM/yyyy')} - ${DateTime.fromJSDate(this.props.dateEnd).toFormat('dd/MM/yyyy')})`
    }

    mount() {
        let columns = []
        switch (this.props.content.type) {
            case 'vendas_sem_numero':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/vendas-sem-numero/${this.props.content.emp}`, columns)
            case 'venda_detalhada':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/venda-detalhada/${this.props.content.emp}`, columns)
            case 'notas_emitidas':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'modelo', text: 'Modelo', sort: false },
                    { dataField: 'situacao', text: 'Situação', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/notas-emitidas/${this.props.content.emp}`, columns)
            case 'diferencas':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/diferencas/${this.props.content.emp}`, columns)
            case 'duplicidades':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'data_saida', text: 'Data', sort: true, formatter: dateFormat, csvFormatter: dateFormat },
                    { dataField: 'numero_nota', text: 'Cupom', sort: true },
                    { dataField: 'modelo', text: 'Modelo', sort: true },
                    { dataField: 'valor_nota', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                    { dataField: 'id_venda', text: 'ID Venda', sort: true },
                    { dataField: 'cfop', text: 'CFOP', sort: true }
                ]
                return this.prepareTable(`/nfce/duplicidades/${this.props.content.emp}`, columns)
            case 'correcoes':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'modelo', text: 'Modelo', sort: false },
                    { dataField: 'situacao', text: 'Situação', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/correcoes-mes-anterior/${this.props.content.emp}`, columns)
            case 'nfs_complementares':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'numero_nota', text: 'Nota', sort: true },
                    { dataField: 'cfop', text: 'CFOP', sort: false },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                    { dataField: 'situacao', text: 'Situação', sort: true }
                ]
                return this.prepareTable(`/nfce/complementares/${this.props.content.emp}`, columns)
            case 'rejeitadas':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/vendas-rejeitadas/${this.props.content.emp}`, columns, 'venda_id')
            case 'notasF':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'modelo', text: 'Modelo', sort: false },
                    { dataField: 'situacao', text: 'Situação', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/nfce/notas-tipo-f/${this.props.content.emp}`, columns)
            default: return
        }
    }

    onClose() {
        this.setState({ dados: [] })
    }

    prepareTable(url, columns, key = 'id', defaultSorted = [{ dataField: 'emissao', order: 'asc' }]) {
        console.log("url", url)

        if (this.state.dados.length === 0) {
            const client = getHTTPClient()
            client({
                method: 'POST',
                url,
                data: {
                    ini: this.props.dateIni,
                    end: this.props.dateEnd
                }
            }).then(response => {
                if (response.data.dados.length) {
                    setTimeout(() => {
                        this.setState({
                            dados: response.data.dados
                        })
                    }, 500)
                } else {
                    showNotification('Não há dados para exibir.')
                    this.closeBtn.current.click()
                }
            })
                .catch(error => {
                    if (error.response)
                        showNotification(error.response.data.message, 'alert-danger')
                    else
                        showNotification('Algo deu errado :/', 'alert-danger')
                    this.closeBtn.current.click()
                })
        }

        return (
            <ToolkitProvider
                keyField={key}
                data={this.state.dados}
                columns={columns}
                search={{ searchFormatted: true }}
                exportCSV
            >
                {props => (
                    <Fragment>
                        <div className="row">
                            <div className="col-12 col-sm-5">
                                <SearchBar placeholder="Pesquisar..." className="form-control-sm" {...props.searchProps} />
                            </div>
                            <div className="col-12 col-sm-2">
                                <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                            </div>
                        </div>

                        <hr />
                        <BootstrapTable
                            {...props.baseProps}
                            bootstrap4
                            hover
                            classes="table-sm"
                            wrapperClasses="table-responsive"
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory({ showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                            noDataIndication={() => <Loader noPage />}
                            ref={this.table}
                        />
                    </Fragment>
                )}

            </ToolkitProvider>
        )

    }

    render() {
        return (
            <Modal size="lg" className="modal-bigger"  isOpen={this.props.shouldShow} toggle={this.props.toggleDetail} onClosed={this.onClose}>
                <ModalHeader toggle={this.props.toggleDetail}>{this.getTitle()}</ModalHeader>
                <ModalBody style={{ fontSize: '.85rem' }}>

                    <p className="mb-2">
                        <strong className="pr-2">Total:</strong>{toMoney(this.state.dados.map(d => d.valor).reduce((acc, valor) => acc + valor, 0))}
                    </p>

                    {this.mount()}

                </ModalBody>
                <ModalFooter>
                    <button ref={this.closeBtn} className="btn btn-secondary" onClick={this.props.toggleDetail}>Fechar</button>
                </ModalFooter>
            </Modal>
        )
    }

}

export default NfceDetail